import React from 'react';
import PropTypes from 'prop-types';

const LibraryListOptions = (props) => (
  <optgroup label={props.category}>
    {
      props.courses.map((course) => (
        <option key={course.id} value={course.slug}>{course.title}</option>
      ))
    }
  </optgroup>
);

LibraryListOptions.propTypes = {
  courses: PropTypes.array,
  category: PropTypes.string
};

export default LibraryListOptions;



// WEBPACK FOOTER //
// ./src/components/LibraryListOptions/index.js